import React, { useState } from "react";
import axios from 'axios';
import { API_PROVEEDORES_URL } from '../../constants';

//Estilos
import "./CuentasEmisoras.css"
import { PencilSquare } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

//Elementos bootstrap
import { Form, Col, Container, Modal } from "react-bootstrap";

//Componentes
import NumberFormat from 'react-number-format';
import SeleccionarEmpresa from '../Requisiciones/SeleccionarEmpresa';

function ModalEditarCuentaEmisora(props) {
    const [status, setStatus] = useState(false);
    const [idEmpresa, setIdEmpresa] = useState(props.children.idEmpresa);
    const [empresa, setEmpresa] = useState(props.children.empresa);
    const [banco, setBanco] = useState(props.children.banco);
    const [comentario, setComentario] = useState(props.children.comentario);
    const [cuenta, setCuenta] = useState(props.children.cuenta);
    const [cuentaClabe, setCuentaClabe] = useState(props.children.cuentaClabe);
    const [referencia, setReferencia] = useState(props.children.referencia);

    function empresaSelected(empresa) {
        var str = empresa;
        var array = str.split(",");
        setEmpresa(array[0]);
        setIdEmpresa(array[1]);
    }

    function handleBancoChange(e) {
        setBanco(e.target.value);
    }
    function handleComentarioChange(e) {
        setComentario(e.target.value);
    }
    function handleCuentaChange(e) {
        setCuenta(e.target.value);
    }
    function handleCuentaClabeChange(e) {
        setCuentaClabe(e.target.value);
    }
    function handleReferenciaChange(e) {
        setReferencia(e.target.value);
    }

    function validateCuentaEmisora() {
        if (!idEmpresa || !empresa) {
            toast.warning('Debes seleccionar una empresa', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        if (banco.trim() === '') {
            toast.error('El campo "Banco" es obligatorio, por favor ingrese la información correspondiente antes de actualizar', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        if (cuenta.trim() === '' && cuentaClabe.trim() === '') {
            toast.error('Debe completar el campo "Cuenta" o "Cuenta Clabe"', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        editCuentaEmisora();
    }

    function editCuentaEmisora() {
        setStatus(true);
        axios.post(API_PROVEEDORES_URL + 'updateCuentaEmisora',
            {
                idCuentaEmisora: props.children.idCuentaEmisora,
                idEmpresa: idEmpresa,
                empresa: empresa,
                banco: banco,
                cuenta: cuenta,
                cuentaClabe: cuentaClabe,
                comentario: comentario,
                referencia: referencia
            }
        ).then((res) => {
            if (res.data.result.success) {
                setStatus(false);
                toast.success(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                props.onHide();//Cierra el modal, llamando a la función padre para cerrarlo
                props.onUpdate();//Actualiza el listado, llamando a la función padre para actualizarlo                       
            } else {
                toast.error(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                toast.error(res.data.result.suggestion,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                setStatus(false);
            }
        }).catch((error) => {
            toast.error("No se ha podido actualizar la cuenta emisora de pago",{
                position:"top-center",
                autoClose: 4500, 
            });
            setStatus(false);
        });
    }

    return (
        <section className="text-center">
            <Modal
                show={props.show}
                //onHide={props.onHide}
                size="md"
                aria-labelledby="example-modal-sizes-title-vcenter"
                id="modalEditarCuentaEmisora"
                centered
            >
                <Modal.Header className="modal-header-editar-cuenta-emisora" closeButton onHide={props.onHide}>
                    <h5 className="legend-editar-cuenta-emisora"><PencilSquare size={22} color="#5B4B51" /> Editar cuenta emisora de pago</h5>
                </Modal.Header>
                <Container>
                    <Modal.Body className="modal-body-cuenta-emisora">
                        <Form>
                            <fieldset >
                                <legend className="legend-editar-cuenta-emisora">Cuenta bancaria</legend>
                                <Form.Row >
                                    <SeleccionarEmpresa onEmpresaSelected={empresaSelected}>{empresa + "," + idEmpresa}</SeleccionarEmpresa>
                                    <Form.Group as={Col}>
                                        <Form.Label>Banco</Form.Label>
                                        <Form.Control type="text" required id="banco"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese banco"
                                            defaultValue={banco}
                                            onChange={handleBancoChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Comentario</Form.Label>
                                        <Form.Control type="text" required id="comentario"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese notas adicionales"
                                            defaultValue={comentario}
                                            onChange={handleComentarioChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta</Form.Label>
                                        <NumberFormat
                                            id="cuenta"
                                            format="#### #### #### #### #### ####"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            required
                                            defaultValue={cuenta}
                                            placeholder="Ingrese número de cuenta"
                                            onChange={handleCuentaChange}
                                        />
                                        <Form.Text muted>Hasta 24 dígitos </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta CLABE</Form.Label>
                                        <NumberFormat
                                            id="cuentaClabe"
                                            format="#### #### #### #### ##"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            required
                                            defaultValue={cuentaClabe}
                                            placeholder="Ingrese cuenta clabe"
                                            onChange={handleCuentaClabeChange}
                                        />
                                        <Form.Text muted>18 dígitos </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Referencia</Form.Label>
                                        <Form.Control
                                            type="text" id="referencia"
                                            placeholder="Ingrese referencia"
                                            className="form-control form-control-sm"
                                            defaultValue={referencia}
                                            onChange={handleReferenciaChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </fieldset>
                        </Form>
                    </Modal.Body>
                </Container>
                <Modal.Footer className="justify-content-end">
                    <button
                        className="m-1 button-default-confirmar"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Guardar cuenta emisora"
                        disabled={status}
                        onClick={validateCuentaEmisora}
                    >{status ?
                        <span>Guardando...</span>
                        : <span>Confirmar</span>}
                    </button>
                    <button
                        className="m-1 button-default-subir-archivo"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancelar"
                        onClick={props.onHide}
                    ><span>Cancelar</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </section>
    );
}

export default ModalEditarCuentaEmisora;